var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explanation-container display-flex flex-align-center flex-row py-1"},[_c('SIcon',{staticClass:"mr-2",attrs:{"name":"create-and-manage-tabs-explanation"}}),_vm._t("default"),_c('SIcon',{staticClass:"dismiss-button",attrs:{"name":"dismiss-tabs-explanation"},nativeOn:{"click":function($event){return _vm.$emit('dismiss')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }